import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const Container = styled.div`
  position: relative;
  overflow: hidden;
  width: ${props => props.width}px;
  height: ${props => props.height}px;
`

const Viewport = ({ width, height, children }) => (
  <Container width={width} height={height}>
    {children}
  </Container>
)

Viewport.propTypes = {
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  children: PropTypes.node,
}

export default Viewport
